@if (editing() || !query()) {
  <input #editor
         class="query-editor"
         type="text"
         autocorrect="off"
         autocapitalize="none"
         i18n-placeholder
         placeholder="Tag Query"
         [value]="query()"
         [attr.data-jasper-clipboard-replace]="replaceOnClipboardPaste() ? 'true' : null"
         (blur)="blur(editor.value)"
         (jasper-clipboard-query-paste)="replaceOnClipboardPaste.set(false)"
         (keydown)="$event.key === 'Enter' && search(editor.value) || true">
  <button type="button" class="query-search-button" (click)="search(editor.value)">🔎️</button>
} @else {
  <div #div class="breadcrumbs query-breadcrumbs" (click)="$event.target === div && edit(false)">
    @for (breadcrumb of breadcrumbs(); track breadcrumb) {
      <span class="crumb">
        @if (breadcrumb.tag) {
          <a class="tag" [routerLink]="['../', breadcrumb.tag]" queryParamsHandling="merge"><span (click)="click($event, breadcrumb)">{{ breadcrumb.text }}</span></a>
        } @else {
          <span class="op" (click)="edit([breadcrumb, breadcrumb])">{{ breadcrumb.text }}</span>
        }
      </span>
    }
  </div>
  <button type="button" class="query-edit-button" (click)="edit(true)">✏️</button>
}
